import React, { useState, useEffect } from 'react';
import './styles/footer.css';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const Footer = () => {
  const [terapiItems, setTerapiItems] = useState([]);

  useEffect(() => {
    const fetchTerapiItems = async () => {
      try {
        const terapiOmraderDocRef = doc(db, 'content', 'terapiOmrader');
        const terapiOmraderDoc = await getDoc(terapiOmraderDocRef);
        
        if (terapiOmraderDoc.exists() && terapiOmraderDoc.data().omrader) {
          setTerapiItems(terapiOmraderDoc.data().omrader.map(o => ({
            id: o.id,
            title: o.title,
            link: `/terapi/${o.id}`
          })));
        }
      } catch (error) {
        console.error('Fejl ved hentning af terapi-områder:', error);
      }
    };

    fetchTerapiItems();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <img src="/media/logo/psykologiskperspektiv-logo.avif" alt="Psykologisk Perspektiv" />
            <div className="footer-kontakt">
              <p>Sankt Annæ Pl. 12, 2. sal</p>
              <p>1250 København, Danmark</p>
              <a href="/kontakt" className="kontakt-link">Se kontaktinfo</a>
            </div>
          </div>

          <div className="footer-menu">
            <div className="footer-menu-section">
              <h3>Behandling</h3>
              <ul>
                {terapiItems.map(item => (
                  <li key={item.id}>
                    <a href={item.link}>{item.title}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-menu-section">
              <h3>Fagligt</h3>
              <ul>
                <li><a href="/supervision">Supervision</a></li>
                <li><a href="/uddannelse">Uddannelse</a></li>
                <li><a href="/viden">Viden</a></li>
                <li><a href="/shop">Shop</a></li>
              </ul>
            </div>

            <div className="footer-menu-section">
              <h3>Information</h3>
              <ul>
                <li><a href="/om">Om os</a></li>
                <li><a href="/praktisk-priser">Praktisk & priser</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">© 2025 Psykologisk Perspektiv. Alle rettigheder forbeholdes.</p>
            <div className="footer-bottom-links">
              <p>Lavet af <a href="https://parlabranding.dk" target="_blank" rel="noopener noreferrer">Parla Branding</a></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
